"use strict";
/**
 * It contains information about the usage of and assessment
 *
 * @property { string } id                       - Assessment template's ID
 * @property { number } totalAssessmentsAssigned - Number of times the assessment template has been assigned
 * @author melany.delgado
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentTemplateUsage = void 0;
var AssessmentTemplateUsage = /** @class */ (function () {
    function AssessmentTemplateUsage(assessmentTemplateUsageOption) {
        if (assessmentTemplateUsageOption === void 0) { assessmentTemplateUsageOption = {}; }
        Object.assign(this, assessmentTemplateUsageOption);
    }
    return AssessmentTemplateUsage;
}());
exports.AssessmentTemplateUsage = AssessmentTemplateUsage;
